const lang = {
    actionButton: {
        confirm: '確認',
        cancel: '取消',
    },
};
export default lang;
